/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import * as actions from '../../types/auth-action.type';

export const updateAuth = (data:any) => ({
  type: actions.SET_AUTH,
  payload: data,
});

export const updateAuthError = (data:any) => ({
  type: actions.SET_AUTH_ERROR,
  payload: data,
});

export const updateAuthSuccess = (data:any) => ({
  type: actions.SET_AUTH_SUCCESS,
  payload: data,
});
